import { Tag } from '@servicetitan/design-system';
import styles from './UrgentFollowUpsBadge.module.css';
import classNames from 'classnames';
import { useEffect } from 'react';
import { SecondChanceLeadsCountExecuteQueryOptions } from '../SecondChanceLeadsModule';
import { AbandonedCallsCountExecuteQueryOptions } from '../AbandonedCallsModule';
import { VaCountExecuteQueryOptions } from '../VirtualAgentFollowUpsModule';
import { VoicemailsCountExecuteQueryOptions } from '../VoicemailsModule';

interface UrgentFollowUpsBadgeProps {
  id: string;
  badgeTitle: string;
  useCountQuery: () => {
    error?: Error;
    previousCount: number | undefined;
    currentCount: number | undefined;
    execute: (
      options?:
        | VaCountExecuteQueryOptions
        | SecondChanceLeadsCountExecuteQueryOptions
        | AbandonedCallsCountExecuteQueryOptions
        | VoicemailsCountExecuteQueryOptions,
    ) => void;
  };
  getFilters: () => any;
}

const UrgentFollowUpsBadge = ({
  id,
  badgeTitle,
  useCountQuery,
  getFilters,
}: UrgentFollowUpsBadgeProps) => {
  const { execute, currentCount, previousCount, error } = useCountQuery();

  useEffect(() => {
    execute({
      variables: {
        filter: getFilters(),
      },
    });

    const interval = setInterval(async () => {
      execute({
        variables: {
          filter: getFilters(),
          take: 1,
        },
      });
    }, 120_000);

    return () => {
      clearInterval(interval);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  let badgeText: number | string | undefined =
    currentCount ??
    // Fall back to any previous fetch's count. This prevents flickering when
    // we render during a slow load.
    previousCount;

  if (error) {
    badgeText = '?';
    badgeTitle = `Error fetching: ${badgeTitle}`;
  }

  return (
    !!badgeText && (
      <Tag
        badge
        compact
        className={classNames(styles.sidenavBadge)}
        style={{
          marginLeft: 'auto',
        }}
        id={id}
        color='critical'
        title={badgeTitle}
      >
        {badgeText}
      </Tag>
    )
  );
};

export default UrgentFollowUpsBadge;
